import React from 'react';
// import { useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.min.css';

type Properties = {
    afterPrevSwipe?: () => void;
    afterNextSwipe?: () => void;
    disableScrolling?: boolean;
    resetKey?: string; // e.g., pathname
};

const MySwiper = (props: React.PropsWithChildren<Properties>) => {
    const { afterNextSwipe, afterPrevSwipe } = props;

    const [swiper, setSwiper] = React.useState<any | null>(null);

    const initialSlide = 1;

    const [initReady, setInitReady] = React.useState(false);

    const handleChangeEnd = React.useCallback(() => {
        if (!initReady || !swiper) {
            return;
        }

        const delta = swiper.activeIndex - initialSlide;

        // Always snap back to middle first to keep indices aligned
        swiper.slideTo(initialSlide, 0, false);

        if (delta < 0) {
            if (afterPrevSwipe) {
                afterPrevSwipe();
            }
        } else if (delta > 0) {
            if (afterNextSwipe) {
                afterNextSwipe();
            }
        }
    }, [initReady, swiper, afterPrevSwipe, afterNextSwipe]);

    let className = 'my-swiper';
    if (!props.disableScrolling) {
        className += ' swiper-with-scroll';
    }

    return (
        <Swiper
            key={props.resetKey} // recreate Swiper on route change
            className={className}
            initialSlide={initialSlide}
            onSwiper={setSwiper}
            onAfterInit={() => setInitReady(true)}
            onSlideChangeTransitionEnd={handleChangeEnd}
            allowSlidePrev={Boolean(afterPrevSwipe)}
            allowSlideNext={Boolean(afterNextSwipe)}
            noSwiping={true}
            noSwipingClass="swiper-no-swiping"
            observer={false} // disable to avoid surprise reflows
            observeParents={false}
        >
            <SwiperSlide />
            <SwiperSlide>{props.children}</SwiperSlide>
            <SwiperSlide />
        </Swiper>
    );
};

export default MySwiper;